import { z } from "zod";

export const updateVigilsPasswordSchema = z.object({
  password: z.string().min(8),
});

export type UpdateVigilsPasswordForm = z.infer<
  typeof updateVigilsPasswordSchema
>;
